import { createContext } from "react";
import type { HorizontalAlignment } from "../CollapsibleList/CollapsibleList";
import type { DropDownDirection } from "../CollapsibleMenu/CollapsibleMenu";

export type ToolbarAlignmentContextData = {
	horizontalAlignment?: HorizontalAlignment;
	dropDownDirection?: DropDownDirection;
};

export const ToolbarAlignmentContext = createContext<ToolbarAlignmentContextData>({});
